import React, { PureComponent } from 'react';
import moment from 'moment';

import { Formik, Form, Field } from 'formik';

import MessagingChannelComponent from './messaging-channel-component';

class MessagingContainerComponent extends PureComponent {
  messagesEnd = null
  constructor(props) {
    super(props);

    this.getType = this.getType.bind(this);
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate(oldProps) {
    let oldMessageLength = oldProps.messages ? oldProps.messages.length : 0;
    let newMessageLength = this.props.messages ? this.props.messages.length : 0;
    if (newMessageLength && newMessageLength !== oldMessageLength) {
      this.scrollToBottom();
    }
  }

  scrollToBottom() {
    let el = document.getElementById('MessagesEnd');
    if (el) {
      let topPos = el.offsetTop;
      document.getElementById('Messages').scrollTop = topPos;
    }
  }

  renderMessage(message, type) {
    let classes = `${type}-message`;

    return (<div key={`message-${message.sid}`} className="row"><div className={classes}>
      <div className="timestamp">{moment(message.timestamp).fromNow()}</div>
      <div className="message-body">{message.body}</div>
    </div></div>)
  }

  getType = (message, user) => {
    if (message.author === 'system')
      return 'system';

    return message.author !== user._id ? 'left' : 'right';
  }

  render() {
    let { user, currentChannel, messages, onSubmit, onBack, isMobile } = this.props;

    if (!currentChannel) {
      return (<div className="col message-messages"><div className="container text-center"><h5>Select a message thread on the left.</h5></div></div>)
    } else {
      let otherUser = ''
      currentChannel.uniqueName.split('-').map(cUserId => { if (cUserId !== user._id) otherUser = cUserId });

      return (
        <div className="col message-messages">
          {isMobile
            && (<MessagingChannelComponent
              key={`mchannel-${currentChannel.uniqueName}`}
              onClick={onBack}
              channel={currentChannel}
              currentUserId={user._id}
              isMobile={isMobile} />)}
          <div id="Messages" className="message-messages-list">
            {messages && messages.map(m => {
              //Align author right; System center; other left
              return this.renderMessage(m, this.getType(m, user))
            })}
            <div id="MessagesEnd" style={{ float: "left", clear: "both" }}
              ref={(el) => { this.messagesEnd = el; }}></div>
          </div>
          <div className="message-messages-send">
            <Formik
              onSubmit={onSubmit}
              initialValues={{ notifyUserId: otherUser, message: '' }}>
              <Form>
                <Field
                  name="message"
                  className="form-control mr-1"
                  component="textarea" />
                <button type="submit" className="btn btn-primary">Send</button>
              </Form>
            </Formik>
          </div>
        </div>
      );
    }
  }
}

export default MessagingContainerComponent;
